export default {
  "ORDER_WAIT_SHIP": "To be shipped",
  "Men fashion": "Men's Clothing",
  "MyAccount_MyProfile_label_First": "First Name",
  "MyAccount_MyShippingDetails_Phone": "Phone Number",
  "Page_not_found_message1": "Sorry, the page you are looking for can't be found.",
  "Help": "Help",
  "Sign in": "Sign In",
  "Register": "Register",
  "Category_sorting_Item": "Select Sorting",
  "cart_clear": "Clear Cart",
  "Payment & Delivery": "Payment and Shipping",
  "Send my feedback": "Send My Feedback",
  "MyAccount_MyProfile_Save": "Save Changes",
  "Continue_billing": "Continue Checkout",
  "Categories": "Categories",
  "Read and understand": "I have read and understand",
  "Feel free to edit": "Feel free to edit any of your details so that your account is always up to date.",
  "Select payment method": "Select Payment Method",
  "Login_input_email": "Your email",
  "Login_input_first": "First Name",
  "Account": "Account",
  "Create_Time_Asc": "Creation time Ascending",
  "concactus_label": "Comments or Questions",
  "Order_Grade": "Order Grade",
  "wishlist_empty_desc": "It looks like you haven't added any items to your shopping bag. Start shopping to fill it up!",
  "cartpreviewShipping_messageinfo": "You will receive confirmation of shipment and arrival date",
  "unsubscribe": "You can unsubscribe at any time.",
  "prompt": "Prompt",
  "MyAccount_MyProfile_yinsi_message": "At Brand name, we take privacy very seriously and are committed to protecting users’ personal data. To learn more about how we care and use your personal data, please see our ",
  "About us": "About Us",
  "or": "or",
  "MyAccount_Order_History_All": "All Orders",
  "What_We_Improve": "How We Improve",
  "MyAccount_ShippingDetails_title": "Shipping Details",
  "MyAccount_Order_History_Tabs2": "Pending Payment",
  "Go_back_shopping": "Go Back Shopping",
  "Product": "Product",
  "Order summary": "Order Summary",
  "payment_order_total": "Total",
  "Departments": "Legal Statement",
  "Download": "Download",
  "Your_Purchase_Order": "Your Order",
  "Your_Account": "Your Account",
  "order_after_sales_list_null": "You currently have no after-sales orders.",
  "All_After_sales_orders": "All After-sales Orders",
  "Filters": "Filters",
  "search_results_not": "We couldn't find any results for the given phrase.",
  "ORDER_WAIT_RECEIPT": "To be received",
  "ORDER_CLOSED": "Closed",
  "Order_View_details": "View Details",
  "Subscribe_to_message": "Be the first to know about upcoming sales and events. Get gifts and special offers!",
  "TaxFee": "Tax and Fee",
  "Apply": "Apply",
  "Total_price": "Total",
  "Description": "Description",
  "Payment method": "Payment Method",
  "Back": "Back",
  "Empty": "It looks like you haven't added any items to your shopping bag. Start shopping to fill it up!",
  "After_sales": "After-sales",
  "Instruction3": "Yes, we know",
  "MyAccount_MyShippingDetails_Last": "Last Name",
  "MyAccount_MyShippingDetails_City": "City",
  "payment_order_discount": "Discount",
  "MyAccount_Order": "Order Details",
  "ID_Name_Error": "Please enter your ID name.",
  "Kidswear": "Kids' Clothing",
  "Share your look": "Share Your Look",
  "Pay_Order": "Pay Order",
  "Reset_Password": "Reset Password",
  "MyAccount_MyProfile_label2_pass1": "Current Password",
  "Create_Time_Desc": "Creation time Descending",
  "Items": "Items",
  "Login_Register": "Register Now",
  "Back to homepage": "Back to Homepage",
  "switch_CNY": "Switch to CNY",
  "Successful placed order": "Thank you for your order. You can use our delivery status function to check the status of your order. You will receive an order confirmation email containing your order details and tracking link.",
  "MyAccount_MyProfile_yinsi_link": "Privacy Policy",
  "Order_Date": "Order Date",
  "Allow order notifications": "Allow Order Notifications",
  "MyAccount_MyProfile_Tab1": "Profile",
  "MyAccount_ShippingDetails_changeTitle": "Change Address",
  "ID_Number": "ID Number",
  "Order_after_sales_message": "Details and after-sales orders",
  "MyAccount_MyProfile_title2": "If you would like to change the password you use to access your account, please provide the following information:",
  "Customer service": "Customer Service",
  "MyAccount_MyProfile_Update": "Update Password",
  "choose_language": "Choose Language",
  "ORDER_REFUNDING": "Refunding",
  "MyAccount_MyProfile_title1": "Feel free to edit any of the details below so that your account is always up to date:",
  "ORDER_WAIT_RATE": "To be rated",
  "after_sales_refund_order": "Order Refund",
  "Who we are": "Who We Are",
  "Women fashion": "Women's Clothing",
  "Personal details": "Personal details",
  "Password": "Password",
  "wishlist_empty_title": "Your wishlist is empty",
  "Repeat_Password": "Repeat Password",
  "cart_price": "Subtotal",
  "Sort_by": "Sort by",
  "Customer Reviews": "Customer Reviews",
  "Continue to shipping": "Continue to shipping",
  "payment_make_order": "Place order",
  "save_order_review": "Submit review",
  "Save_Password": "Save Password",
  "cart_empty_title": "Your cart is empty",
  "TopBar_help": "Help & FAQs",
  "colseCookie": "Got it",
  "Password_Changed": "Your password has been successfully changed. You can now return to the homepage and log in.",
  "Forgot Password Modal Email": "Email address you use to log in:",
  "MyAccount_Personal": "Personal Information",
  "cartPreviewShipping": "Express shipping",
  "ORDER_AFTER_SALE": "After-sale",
  "Page_not_found": "Page not found",
  "Find out more": "Find out more",
  "Log into your account": "Log into your account",
  "Details_and_status_orders": "Check the details and status of your orders in our online store. You can also cancel orders or request returns.",
  "Order_to_be_paid_message": "To be paid",
  "Guarantee": "Guarantee",
  "Sections that interest you": "Sections that interest you",
  "payment_post_tax": "Tax",
  "ORDER_PAID": "Paid",
  "concactus_label5": "Title",
  "Item": "Item",
  "Go_back": "Go back",
  "more": "More",
  "MyAccount": "My Account",
  "payment_agree_1": "I agree to the",
  "total_items": "Total Items",
  "shopping_go": "Manage shipping addresses",
  "ID_Type": "ID Type",
  "after_sales_status": "After-sale status",
  "After_sales_apply": "Apply for after-sale service",
  "Login": "Log in",
  "Quantity": "Quantity",
  "payment_post_fee": "Postage",
  "MyAccount_Log_out": "Log out",
  "Subtotal": "Subtotal",
  "forgotPasswordConfirmation": "Thank you! If an account is associated with {0}, you should receive an email shortly with a link to reset your password.",
  "MyAccount_Order_History_Tabs1": "My Orders",
  "concactus_img": "Upload Images",
  "Done": "Done",
  "Info after order": "You can log in to your account using the email address and password you defined earlier. In your account, you can edit your personal profile, view transaction history, edit newsletter subscriptions, and more.",
  "MyAccoubnt_Set_newsletter": "Set up your newsletter and we will send you new product and trends information every week for the sections you choose.",
  "Shipping_method": "Shipping Method",
  "after_sales_refund": "Refund amount",
  "After_sales_save": "Save after-sale service information",
  "go_order_history": "View order history",
  "contactus_message_placeholder": "Please type your comments or questions here",
  "Login_Forgot_Password": "If you have forgotten your password, you can reset your password here.",
  "show_more": "Show More",
  "MyAccount_MyProfile_label_email": "Your email address",
  "MyAccount_MyProfile_label2_pass3": "Repeat Password",
  "Products": "Products",
  "Review": "Review",
  "MyAccount_MyProfile_title3": "Your current email address is",
  "Category_found_Products": "Products found",
  "Match": "Match",
  "Read_all_reviews": "Read All Reviews",
  "Commercial information": "and agree to receive personalized commercial information from Brand name by email",
  "Change password your account": "If you would like to change the password you use to access your account, please enter the following information",
  "ID_Name": "ID Name",
  "All": "All",
  "Instruction2": "Only need care instructions?",
  "MyAccount_ShippingDetails_Add": "Add a new address",
  "MyAccount_MyShippingDetails_Zip": "Postal Code",
  "go_pay_order": "Pay now",
  "Thank_You_Inbox": "If the message is not in your inbox, try using another email address that you may have used to register.",
  "Subscribe": "Subscribe",
  "confirm_subscription": "I confirm my subscription",
  "Login_input_Remember": "Remember me",
  "Add to compare": "Add to compare",
  "Brand": "Brand",
  "Start_shopping": "Start Shopping",
  "Select shipping method": "Select shipping method",
  "address CN": "Address is in China, current currency must be CNY",
  "MyAccount_MyShippingDetails_State": "State/Province",
  "Page_not_found_message2": "Please go back or try again.",
  "Go_to_checkout": "Go to checkout",
  "See all results": "See all results",
  "search_results_inputnull": "You haven't searched for anything yet.",
  "subscribeToNewsletterModalContent": "By subscribing to our newsletter, you will receive special offers and information from VSF by email. We will not sell or distribute your email at any time to any third party. Please see our {0}.",
  "Download all": "Download all",
  "Login_input_last": "Last Name",
  "Amount": "Amount",
  "ORDER_WAIT_PAYMENT": "Pending",
  "Order_After_sales": "Order After-sales",
  "concattus_button": "Submit",
  "Shipping_valid_required": "This field is required",
  "Price": "Price",
  "ID_Type_Error": "Please select your ID type",
  "Order_Status": "Order status",
  "Payment methods": "Payment methods",
  "MyAccount_MyProfile_Tab2": "Change password",
  "Show on page": "Show on page",
  "Edit": "Edit",
  "Change": "Change",
  "MyAccount_ShippingDetails_Update": "Update address",
  "View": "View",
  "Privacy": "Privacy",
  "Enter_promo_code": "Enter promo code",
  "Discount": "Discount",
  "Delete": "Delete",
  "Wishlist": "Wishlist",
  "MyAccount_Order_History_Tabs3": "Return",
  "Go_To_Order_review": "Go to review",
  "Update personal data": "Update personal data",
  "payment_agree_2": "Terms and conditions",
  "or fill the details below": "or fill the details below",
  "Contact details updated": "Keep your address and contact details updated.",
  "Login_Create": "Create Account",
  "Payment": "Payment",
  "Billing": "Billing",
  "payment_insurance_tax": "Insurance tax",
  "Size guide": "Size guide",
  "Login_forgotten_password": "Forgot password?",
  "Login_no_account": "Don't have an account?",
  "Privacy_Policy": "Privacy policy",
  "BootomCookieTitle": "Cookie consent",
  "Use your personal data": "At Brand name, we take privacy seriously and are committed to protecting the personal data of our users. Learn more about how we care for and use your personal data in our",
  "Review my order": "Review my order",
  "BootomCookieLink": "Find out more",
  "hide": "Hide",
  "MyAccount_ShippingDetails_message_title": "Manage all the delivery addresses you want (workplace, home addresses, etc.) so you don't have to manually enter the delivery address in each order.",
  "Purchase terms": "Purchase terms",
  "Billing_address": "Billing address",
  "Manage shipping addresses": "Manage all the delivery addresses you want (workplace, home addresses, etc.) so you don't have to manually enter the delivery address in each order.",
  "login_logbtn": "Log in to account",
  "choose_currency": "Choose currency",
  "ORDER_REFUNDED": "Refunded",
  "After_sales_form": "Fill in the after-sales form",
  "add_To_Wishlist": "Add to wishlist",
  "search_results_inputnull2": "Start now and we'll help you.",
  "Total": "Total",
  "Subscribe_to_newsletter": "Subscribe to newsletter",
  "Shipping_valid_Phone": "Please enter a valid phone number",
  "concactus_label3": "Title",
  "Manage billing addresses": "Manage all the billing addresses you want (workplace, home addresses, etc.) so you don't have to manually enter the billing address in each order.",
  "Search_results_title": "Search results",
  "payment_order_payment": "Order payment",
  "after_sales_Id": "After-sales ID",
  "cart_title": "My Cart",
  "Order_Detail": "Order detail",
  "concactus_label2": "Store Link",
  "Shipping_valid_length_min": "This field should have at least {min} characters.",
  "Product suggestions": "Product suggestions",
  "Return_home": "Return home",
  "Quality in the details": "Quality in the details",
  "Continue_to_payment": "Continue to payment",
  "Feedback": "Your feedback is important to us. Tell us what we can improve.",
  "Go back to shop": "Go back to shop",
  "Back_to_home": "Back to home",
  "Review_Content": "Review content",
  "add_To_Cart": "Add to cart",
  "Read_reviews": "Read reviews",
  "Instruction1": "Care instructions",
  "Email_address": "Email address",
  "Category_Item_List": "Switch to list view",
  "Same as shipping address": "Same as shipping address",
  "Category_Item_Grid": "Switch to grid view",
  "ID_Number_Error": "Please enter your ID number",
  "concactus_label4": "Contact Email",
  "Additional_info": "Additional information",
  "add_shipping": "Add new shipping address",
  "Product_description": "The Karissa V-Neck Tee features a semi-fitted design that works for all body types. It hugs curves and covers common \"problem\" areas, allowing you to work out with confidence. It also features stunning women's cocktail and party dresses.",
  "Login_create_account": "I want to create an account",
  "after_sales_Reason": "After-sales reason",
  "MyAccount_MyProfile_label_Last": "Last name",
  "MyAccount_MyProfile_label2_pass2": "New password",
  "Save": "Save",
  "CartSliderTextBtn": "Save for later purchase",
  "Color": "Color",
  "Shipping_Tax": "Shipping tax",
  "Subscribe_to_success": "You have subscribed",
  "Enjoy your free account": "Enjoy your free account privileges!",
  "cart_empty_desc": "Looks like you haven't added any items to your bag yet. Start shopping to fill it up.",
  "MyAccount_ShippingDetails_message_title2": "Keep your address and contact details updated.",
  "An_error_occured": "An error occurred",
  "Country": "Country",
  "MyAccount_MyShippingDetails_First": "First name",
  "payment_insurance_fee": "Insurance fee",
  "Home": "Home",
  "Contact_us": "Contact us",
  "Cookies Policy": "Cookies Policy",
  "Clear all": "Clear All",
  "Basket": "Basket",
  "MyAccount_MyProfile_reqeatPassErrMsg": "New Password Inconsistent",
  "Your current email address is": "Your Current Email Address Is",
  "You currently have no orders": "You Currently Have No Orders",
  "Login_input_password": "Password",
  "Promo_code": "Promo code",
  "order_count": "Order count",
  "email_geshi_error": "Please enter a valid email address",
  "your_email": "Your email",
  "email": "Email",
  "you_have_subscribed": "You have subscribed",
  "cancel_Subscribe": "Unsubscribe",
  "save_and_pay": "Save and pay",
  "hasInsurance": "Whether to purchase insurance",
  "pleasePayType": "Please select the payment method",
  "zhuanfa_toBePay": "Transfer to a friend to pay for you",
  "linkCopied": "Link copied, go and paste it to share with friends.",
  "Links": "Links",
  "article_category": "Article Category",
  "wechat_code_login_message": "Please scan the QR Code using WeChat to log in",
  "wechat_code_login": "WeChat QR Code Login",
  "Api_Update_success": "Update Success",
  "Please_Use_WeChat_login": "Please log in using WeChat",
  "mobile_geshi_error": "Please enter a valid phone number",
  "Login_input_email_required": "Please enter an email address",
  "article_null": "No articles available",
  "Login_with_microsoft": "Microsoft login",
  "article_null_des": "You can browse articles in other categories",
  "register_email": "Email registration",
  "Login_tab_email": "Email login",
  "code.time": "{time} seconds to retry",
  "Login_with_wechat": "WeChat login",
  "cat_items_null_des": "You can browse products in other categories",
  "Login_with_facebook": "Facebook login",
  "Login_input_code": "Verification code",
  "Login_input_mobile_required": "Please enter a phone number",
  "Login_input_mobile": "Your phone number",
  "cat_items_null": "No items available in this category",
  "Login_with_twitter": "Twitter login",
  "mobile_code": "Verification code",
  "register_mobile": "Mobile registration",
  "Login_tab_mobile": "Mobile login",
  "Login_with_google": "Google login",
  "OrderSku": "Commodity specifications",
  "Order_logisticsNo": "Logistics number",
  "order_shopping_firstname": "Name",
  "Order_logisticsName": "Logistics company",
  "ItemPrice": "Item Price",
  "inPayOrderAll": "Payment Pending List",
  "payPrice": "Payment Amount",
  "shipping_add_success": "Shipping address created successfully",
  "match_goods": "Hot selling goods",
  "pay_code_refresh": "Refresh Payment Code",
  "pay_code_shixiao": "Payment QR Code has expired",
  "concactus_title": "Contact Us",
  "Search_items": "Search",
  "WebAutoLang": "Your current browser recommends language is: {lang}, do you want to switch to this language?",
  "Services_Name": "Service name",
  "Services_Price": "Service fee",
  "SwichLang": "Switch language",
  "Services_Description": "Service description",
  "goodinfo_null": "No Products Available",
  "goodinfo_null_des": "You can browse products in other categories",
  "notYetUseCode": "Unused coupon",
  "guest_Login": "Guest login",
  "billing_and_shipping": "Bill and shipping address consistent",
  "select_coupon": "Select coupon",
  "select_gift": "Select gift",
  "currentUseCode": "Used coupon",
  "shipping_refresh": "Refresh list",
  "Shipping_details": "Delivery Address",
  "MyAccount_Newsletter": "Newsletter",
  "MyAccount_Profile": "Profile",
  "MyAccount_Wishlist": "Wishlist",
  "See_all": "All",
  "MyAccount_History": "Order history",
  "bind_microsoft": "Bind Microsoft",
  "bind_twitter": "Bind Twitter",
  "bind_facebook": "Bind Facebook",
  "bind_wechat_code": "WeChat QR Code",
  "bind_wechat": "Bind WeChat",
  "bind_google": "Bind Google",
  "Wishlist_Empty": "No wishlist",
  "discount_post_fee": "Postage discount",
  "ORDER_PART_PAID": "Partially paid",
  "claimCouponeSuccess": "Claim {name} Successfully",
  "discount_kou": "{discount}折",
  "cartPreviewSafety_messageinfo": "Safe and fast delivery to your address",
  "Order_No": "Order Number",
  "cartPreviewSafety": "Safe Delivery",
  "Shipping": "Shipping",
  "MyAccount_MyShippingDetails_Street": "Street",
  "MyAccount_MyShippingDetails_HouseNumber": "House Number",
  "Shipping_title": "Delivery Address",
  "Offline_payment": "Offline Payment",
  "shopName": "Shop Name",
  "Social": "Social",
  "SERVICE": "Service",
  "onlineContact": "Online Contact",
  "confirm": "Confirm",
  "closeOrder": "Cancel Order",
  "closeOrderContext": "Are you sure you want to cancel the order?",
  "Message_Read": "Read",
  "close.order.success": "Order cancelled successfully.",
  "shippingAddress": "Detailed Address",
  "Message": "Message",
  "Message_Empty_Title": "Your message is empty",
  "MyAccount_Message": "Message",
  "Message_Empty": "No message",
  "payment_order_note": "Order Remarks",
  "go_to_see_prepid": "Click here to see unpaid orders",
  "operate": "Operation",
  "removeCartItemContext": "Are you sure you want to remove {title}?",
  "shippingItemQty": "Shipping Quantity",
  "removeCartItem": "Remove Item",
  "shippingInfo": "Shipping Information",
  "Distributor_success": "Already successfully as a distributor",
  "Distributor_apply": "Apply to become a distributor",
  "Distributor_Details": "Distributor details",
  "DistributorSataus": "Status",
  "Distributor_Details_Empty": "No distributors yet",
  "distributor.status.4": "Voided",
  "distributor.status.1": "Not reviewed",
  "Distributor_copy_url": "Copy distributor link",
  "Order_Time": "Order time",
  "Order_User": "Order user",
  "Distributor_copy_success": "Copy succeeded",
  "distributor.status.3": "Settled",
  "MyAccount_Distributor": "Distributors",
  "MyAccoubnt_Set_Distributor": "Apply to become a distributor",
  "distributor.status.2": "Pending settlement",
  "DistributorAmount": "Commission",
  "Distributor_shenheshibai": "Distributor audit failed",
  "Distributor_shenhezhong": "Distributor under review",
  "Distributor_Order_Empty": "No distributor orders",
  "NE": "Niger",
  "DJ": "Djibouti",
  "KP": "North Korea",
  "US": "United States",
  "LC": "Saint Lucia",
  "NL": "Netherlands",
  "CD": "Democratic Republic of the Congo",
  "IS": "Iceland",
  "MA": "Morocco",
  "GH": "Ghana",
  "KR": "South Korea",
  "MK": "Macedonia",
  "HT": "Haiti",
  "PF": "French Polynesia",
  "GA": "Gabon",
  "TD": "Chad",
  "LB": "Lebanon",
  "CG": "Congo",
  "KG": "Kyrgyzstan",
  "TA": "Tristan da Cunha",
  "KW": "Kuwait",
  "TL": "East Timor",
  "IN": "India",
  "NO": "Norway",
  "NG": "Nigeria",
  "AQ": "Antarctica",
  "LY": "Libya",
  "NI": "Nicaragua",
  "TT": "Trinidad and Tobago",
  "HM": "Heard Island and McDonald Islands",
  "PY": "Paraguay",
  "BA": "Bosnia and Herzegovina",
  "JP": "Japan",
  "MD": "Moldova",
  "MT": "Malta",
  "RE": "Reunion",
  "UG": "Uganda",
  "SB": "Solomon Islands",
  "SL": "Sierra Leone",
  "CV": "Cape Verde",
  "SD": "Sudan",
  "FO": "Faroe Islands",
  "ZA": "South Africa",
  "TR": "Turkey",
  "FK": "Falkland Islands (Malvinas)",
  "PA": "Panama",
  "GF": "French Guiana",
  "TJ": "Tajikistan",
  "NC": "New Caledonia",
  "PM": "Saint Pierre and Miquelon",
  "NU": "Niue",
  "AO": "Angola",
  "VN": "Vietnam",
  "GN": "Guinea",
  "MW": "Malawi",
  "BY": "Belarus",
  "IM": "Isle of Man",
  "BI": "Burundi",
  "BS": "Bahamas",
  "CK": "Cook Islands",
  "MH": "Marshall Islands",
  "CR": "Costa Rica",
  "HK": "Hong Kong SAR China",
  "AD": "Andorra",
  "BN": "Brunei",
  "SN": "Senegal",
  "AE": "United Arab Emirates",
  "GI": "Gibraltar",
  "CA": "Canada",
  "AX": "Åland Islands",
  "UY": "Uruguay",
  "WF": "Wallis and Futuna",
  "GM": "Gambia",
  "SO": "Somalia",
  "RU": "Russia",
  "PL": "Poland",
  "FM": "Micronesia, Federated States of",
  "ET": "Ethiopia",
  "EE": "Estonia",
  "SK": "Slovakia",
  "AS": "American Samoa",
  "ZM": "Zambia",
  "AL": "Albania",
  "AT": "Austria",
  "VA": "Holy See (Vatican City State)",
  "TW": "Taiwan, Province of China",
  "BD": "Bangladesh",
  "AR": "Argentina",
  "EH": "Western Sahara",
  "MO": "Macao SAR China",
  "MV": "Maldives",
  "GU": "Guam",
  "AW": "Aruba",
  "AI": "Anguilla",
  "CL": "Chile",
  "IL": "Israel",
  "GD": "Grenada",
  "WS": "Samoa",
  "SE": "Sweden",
  "GP": "Guadeloupe",
  "YE": "Yemen",
  "GT": "Guatemala",
  "BG": "Bulgaria",
  "SJ": "Svalbard and Jan Mayen",
  "CO": "Colombia",
  "LS": "Lesotho",
  "LV": "Latvia",
  "UM": "U.S. Outlying Islands",
  "MX": "Mexico",
  "DO": "Dominican Republic",
  "PE": "Peru",
  "HN": "Honduras",
  "TC": "Turks and Caicos Islands",
  "VI": "U.S. Virgin Islands",
  "FJ": "Fiji",
  "MP": "Northern Mariana Islands",
  "AC": "Ascension Island",
  "NA": "Namibia",
  "SZ": "Eswatini",
  "RW": "Rwanda",
  "BH": "Bahrain",
  "KN": "Saint Kitts and Nevis",
  "TN": "Tunisia",
  "AF": "Afghanistan",
  "VG": "British Virgin Islands",
  "KE": "Kenya",
  "PK": "Pakistan",
  "GL": "Greenland",
  "SY": "Syria",
  "CU": "Cuba",
  "RS": "Serbia",
  "BF": "Burkina Faso",
  "BM": "Bermuda",
  "BZ": "Belize",
  "SV": "El Salvador",
  "CN": "China",
  "MF": "St. Martin",
  "NF": "Norfolk Island",
  "MZ": "Mozambique",
  "LU": "Luxembourg",
  "TO": "Tonga",
  "GR": "Greece",
  "SI": "Slovenia",
  "PW": "Palau",
  "TZ": "Tanzania",
  "IR": "Iran",
  "GG": "Guernsey",
  "SM": "San Marino",
  "TF": "French Southern Territories",
  "PS": "Palestinian Territories",
  "SC": "Seychelles",
  "BT": "Bhutan",
  "JM": "Jamaica",
  "BR": "Brazil",
  "CH": "Switzerland",
  "SH": "Saint Helena",
  "HU": "Hungary",
  "TM": "Turkmenistan",
  "LT": "Lithuania",
  "MC": "Monaco",
  "LI": "Liechtenstein",
  "LR": "Liberia",
  "GE": "Georgia",
  "SA": "Saudi Arabia",
  "GB": "United Kingdom",
  "VE": "Venezuela",
  "MU": "Mauritius",
  "HR": "Croatia",
  "SR": "Suriname",
  "CM": "Cameroon",
  "IQ": "Iraq",
  "BO": "Bolivia",
  "MN": "Mongolia",
  "DZ": "Algeria",
  "TK": "Tokelau",
  "MG": "Madagascar",
  "YT": "Mayotte",
  "CC": "Cocos (Keeling) Islands",
  "LA": "Laos",
  "PT": "Portugal",
  "QA": "Qatar",
  "AN": "Netherlands Antilles",
  "PN": "Pitcairn Islands",
  "ES": "Spain",
  "VC": "Saint Vincent and the Grenadines",
  "AU": "Australia",
  "CX": "Christmas Island",
  "KM": "Comoros",
  "MR": "Mauritania",
  "FR": "France",
  "SG": "Singapore",
  "BV": "Bouvet Island",
  "PH": "Philippines",
  "CY": "Cyprus",
  "TV": "Tuvalu",
  "CF": "Central African Republic",
  "EC": "Ecuador",
  "GW": "Guinea-Bissau",
  "IE": "Ireland",
  "LK": "Sri Lanka",
  "ER": "Eritrea",
  "GQ": "Equatorial Guinea",
  "NP": "Nepal",
  "BE": "Belgium",
  "GY": "Guyana",
  "DK": "Denmark",
  "MQ": "Martinique",
  "UZ": "Uzbekistan",
  "CI": "Côte d'Ivoire",
  "ID": "Indonesia",
  "BJ": "Benin",
  "ST": "São Tomé and Príncipe",
  "KH": "Cambodia",
  "KZ": "Kazakhstan",
  "MS": "Montserrat",
  "TH": "Thailand",
  "FI": "Finland",
  "ML": "Mali",
  "AM": "Armenia",
  "IT": "Italy",
  "NR": "Nauru",
  "PG": "Papua New Guinea",
  "ZW": "Zimbabwe",
  "JO": "Jordan",
  "OM": "Oman",
  "ME": "Montenegro",
  "JE": "Jersey",
  "NZ": "New Zealand",
  "VU": "Vanuatu",
  "DE": "Germany",
  "CZ": "Czech Republic",
  "DM": "Dominica",
  "KY": "Cayman Islands",
  "BW": "Botswana",
  "RO": "Romania",
  "PR": "Puerto Rico",
  "AZ": "Azerbaijan",
  "IO": "British Indian Ocean Territory",
  "UA": "Ukraine",
  "TG": "Togo",
  "MY": "Malaysia",
  "AG": "Antigua and Barbuda",
  "EG": "Egypt",
  "GS": "South Georgia and South Sandwich Islands",
  "MM": "Myanmar",
  "BB": "Barbados",
  "KI": "Kiribati",
  "All_Country": "all",
  "post_state_country": "Shipping cost: {country} {state} {postFee}",
  "zhichiDeliveryCountry": "Delivery to",
  "ShippingFee": "Shipping fee",
  "reviewOutOf": "{rating} stars, out of 5",
  "product.pifa.label": "Buy {startnum} - {endnum} pieces",
  "product.pifa.type.1": "Discount",
  "Write_a_review": "Write a review",
  "BasedOnTotalReviews": "Based on {total} reviews",
  "product.wholesale": "Wholesale price",
  "reviewMostRecent": "Most recent reviews",
  "product.pifa.type.2": "Unit price",
  "product.num.danwei": "piece",
  "good.shoppingDateLabel": "Shipping Time",
  "good.shippingPeriod": "Shipped Within Days",
  "emailError": "Email format error",
  "claimCoupone": "Get",
  "addressNote": "Remark",
  "Concactus": "Contact",
  "addressMessage": "Please make sure your address is correct. We cannot change it after checkout.",
  "showOrderSummary": "Order Summary",
  "payment_method": "Payment Method",
  "emailNotNullError": "Email cannot be blank",
  "orderCreateLoading": "Creating Order...",
  "emailNote": "Contact",
  "emailMessage": "Please make sure your email address is correct. We will send you an order confirmation email.",
  "payment_method_message": "All transactions are secure and encrypted.",
  "go_buy_goods": "Continue shopping",
  "tap_cancel_order": "Click here to cancel the order",
  "order_review": "Order Review",
  "Add_new_address": "Add new address",
  "promo_code_type_3": "Full gift coupon",
  "IdCardNotNull": "Please fill in real name information",
  "UploadVideo": "Upload video",
  "video": "Video",
  "UploadImage": "Upload image",
  "uploadImageing": "Uploading...",
  "BillingInfoNotNull": "Billing information is incomplete",
  "promo_code_type_2": "Voucher",
  "UploadError": "Upload failed",
  "promo_code_type_4": "Reduce shipping coupon",
  "image": "Image",
  "paymentMethodNotNull": "Please select payment method",
  "promo_code_type_1": "Discount coupon",
  "shippingInfoNotNull": "Shipping information is incomplete",
  "reviewDetail": "Evaluation Details",
  "DeliveryCountry": "Delivery country",
  "prompt_error": "Tip error",
  "save_review_success": "Save review success",
  "ORDER_COMPLETED": "Completed",
  "crate_after_sales": "Create after-sale",
  "Thank_You_Order": "Thank you for your order!",
  "Thank_You_Order_sub": "We will start processing your order shortly and you will receive an email with information about your order processing.",
  "BootomCookieContext": "This website uses cookies to help it operate effectively and to help us understand how to interact with it. We use these cookies to provide you with a better personalized user experience. If you continue to use this site, we will assume that you agree to ",
  "order_reivice_message": "Have you received the goods?",
  "order_reivice_btn": "Confirm receipt",
  "order_reivice_label": "Order receipt",
  "order_reivice_success": "Receipt confirmed",
  "collpase_show": "View more",
  "collpase_hide": "Close",
  "CouponCode": "coupon code",
  "wechatPayScannerCode": "Please use WeChat to scan and pay",
  "processing": "After-sales processing",
  "finished": "After-sales completed",
  "login.showPrice": "Login to view price",
  "After_Sales_Unknown": "After-sales status unknown",
  "order_payment_list_null": "No pending payment orders",
  "Cancel": "Cancel",
  "thankyou_concat": "If you have any questions, please contact us"
}